module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Bold.0c31635.woff2";